import { render, staticRenderFns } from "./ResourceDetailCredentials.vue?vue&type=template&id=2ebc1f3d"
import script from "./ResourceDetailCredentials.vue?vue&type=script&lang=js"
export * from "./ResourceDetailCredentials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports